import axiosInstance from "auth/FetchInterceptor";
import { BANG_LUONG_API } from "constants/ApiConstant";
const QuanLyLuongService = {};

QuanLyLuongService.gridSearchBangLuong = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/search`, data);
};

QuanLyLuongService.getBangLuongById = function (id) {
  return axiosInstance.get(`${BANG_LUONG_API}/get-by-id?id=${id}`);
};

QuanLyLuongService.upSert = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/up-sert`, data);
};

QuanLyLuongService.delete = function (id) {
  return axiosInstance.delete(`${BANG_LUONG_API}/delete?id=${id}`);
};
QuanLyLuongService.changeStateBangLuong = function (id) {
  return axiosInstance.put(`${BANG_LUONG_API}/change-state?id=${id}`);
};
QuanLyLuongService.gridSearchBangLuongNhanVien = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/search-luong-nhan-vien`, data);
};

QuanLyLuongService.gridSearchBangCongLuong = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/search-bang-cong`, data);
};
QuanLyLuongService.duyetBangLuong = function (id) {
  return axiosInstance.put(`${BANG_LUONG_API}/duyet-bang-luong?id=${id}`);
};

QuanLyLuongService.gridSearchBangPhuCapGiamTruLuong = function (data) {
  return axiosInstance.post(
    `${BANG_LUONG_API}/search-bang-phu-cap-giam-tru`,
    data
  );
};

QuanLyLuongService.updateBangLuongNhanVien = function (data) {
  return axiosInstance.put(
    `${BANG_LUONG_API}/update-bang-luong-nhan-vien`,
    data
  );
};

QuanLyLuongService.updatedBangLuongNhanVienById = function (data) {
  return axiosInstance.put(`${BANG_LUONG_API}/update-nhanvien-by-id`, data);
};

QuanLyLuongService.sentMail = function (id) {
  return axiosInstance.get(`${BANG_LUONG_API}/chi-tiet/sent-mail?id=${id}`);
};

QuanLyLuongService.export = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/chi-tiet/export`, data);
};

QuanLyLuongService.exportDefault = function (data) {
  return axiosInstance.post(`${BANG_LUONG_API}/chi-tiet/export-default`, data);
};

QuanLyLuongService.import = function (data) {
  return axiosInstance.get(
    `${BANG_LUONG_API}/chi-tiet/import?transId=${data.transId}&bangLuongId=${data.bangLuongId}`
  );
};

QuanLyLuongService.updateImportSync = function (data) {
  return axiosInstance.post(
    `${BANG_LUONG_API}/chi-tiet/import-update-by-transId`,
    data
  );
};

QuanLyLuongService.updatedTinhLuongNhanVienByIds = function (data) {
  return axiosInstance.put(`${BANG_LUONG_API}/TinhLuong/update-by-ids`, data);
};

QuanLyLuongService.updatedTinhLuongNhanVienById = function (id) {
  return axiosInstance.put(`${BANG_LUONG_API}/TinhLuong/update-by-id?id=${id}`);
};

QuanLyLuongService.getDepartmentByBangLuong = function (id) {
  return axiosInstance.get(
    `${BANG_LUONG_API}/get-department?bangLuongId=${id}`
  );
};

QuanLyLuongService.updateMucDoHoanThanhByDepartment = function (data) {
  return axiosInstance.put(`${BANG_LUONG_API}/update-kpi`, data);
};

export default QuanLyLuongService;
